import type { SeatingChart as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util/takePayload';

/**
 * The identifying slice of a seating chart, for fragments that only need to
 * name it (or test for its presence). The full `SeatingChart` mapper requires
 * `key`/`deletable`/`usable`, which those fragments deliberately do not select.
 */
export type SeatingChartSummary = {
  id: number;
  name: string;
};

export const fromGql = (item: GQLItem): SeatingChartSummary =>
  take<SeatingChartSummary>(item, 'id', 'name');
